<template>
  <v-card elevation="0">
    <v-card-title>لطفا مقادیر درخواستی را وارد کنید</v-card-title>
    <v-col cols="12" md="6" v-for="(gate, i) in valueGate.config" :key="i">
      <v-text-field outlined :label="gate.name" v-model="gate.value" />
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: "gateSetting",
  props: {
    value: Object,
  },

  computed: {
    valueGate: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style></style>
